import { FC, useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import { FormattedMessage } from 'react-intl'
import { Stack, Card, Heading, Text } from '@instabox/consumer-web-ui'
import {
  GetMarketByIdQuery,
  OpeningHour,
  formatOpeningHours,
  formatSpecialOpeningHours,
  FormattedOpeningHour,
} from '@instabox/consumer-web-shared'

import ContactUsLink from '../ContactUsLink'

export type ContactUsProps = GetMarketByIdQuery['marketById'] & {
  headingSize?: 'sm' | 'md'
}

const ContactUs: FC<ContactUsProps> = ({
  email,
  opening_hours: openingHours = [],
  special_opening_hours: specialOpeningHours = [],
  phone,
  sms,
  headingSize = 'md',
}) => {
  const [formattedOpeningHours, setFormattedOpeningHours] = useState<FormattedOpeningHour[]>([])
  const [formattedSpecialOpeningHours, setFormattedSpecialOpeningHours] = useState<
    FormattedOpeningHour[]
  >([])
  const { locale } = useRouter()

  useEffect(() => {
    setFormattedOpeningHours(
      formatOpeningHours({
        openingHours,
        locales: locale,
      }),
    )
    setFormattedSpecialOpeningHours(
      formatSpecialOpeningHours({
        openingHours: specialOpeningHours,
        locales: locale,
      }),
    )
  }, [openingHours, specialOpeningHours, locale])

  return (
    <Card variant="secondary" size="md">
      <Stack gap="lg">
        <Heading color="white" as="h6" fontSize={headingSize}>
          <FormattedMessage id="help.need_more_help" />
        </Heading>
        {(email || phone || sms) && (
          <Stack gap="sm">
            {email && <ContactUsLink type="email" value={email} color="white" />}
            {phone && <ContactUsLink type="phone" value={phone} color="white" />}
            {sms && <ContactUsLink type="sms" value={sms} color="white" />}
          </Stack>
        )}
        <Stack gap="sm">
          <Text color="white" fontWeight="medium">
            <FormattedMessage id="general.opening_hours" />
          </Text>
          <Stack as="ul" gap="xs">
            {formattedOpeningHours.map((openingHour, index) => (
              <li key={index}>
                <Text color="white" as="span">
                  <OpeningHour {...openingHour} />
                </Text>
              </li>
            ))}
          </Stack>
          {formattedSpecialOpeningHours.length > 0 && (
            <>
              <Text color="white" fontWeight="medium">
                <FormattedMessage id="general.special_opening_hours" />
              </Text>
              <Stack as="ul" gap="xs">
                {formattedSpecialOpeningHours.map((openingHour, index) => (
                  <li key={index}>
                    <Text color="white" as="span">
                      <OpeningHour {...openingHour} />
                    </Text>
                  </li>
                ))}
              </Stack>
            </>
          )}
        </Stack>
      </Stack>
    </Card>
  )
}

export default ContactUs
